import createEnhancedAsynThunk from '../../utils/createEnhancedAsynThunk';
import sliceHandler from '../../utils/sliceHandler';

const sliceArgs = {
  SLICE_NAME: 'promotions',
  ENDPOINT: 'orders',
  RESOURCE: 'promotions',
};

const sliceName = sliceArgs.SLICE_NAME;

const fetchPromotions = createEnhancedAsynThunk({
  name: sliceArgs.SLICE_NAME,
  endpoint: sliceArgs.ENDPOINT,
  resource: sliceArgs.RESOURCE,
  method: 'PATCH',
});

const extraReducers = [fetchPromotions];

const slice = sliceHandler({ sliceName, extraReducers });
const { actions, reducer } = slice;

export const { resetPromotionData } = actions;
export { fetchPromotions };
export default reducer;
